import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";

interface IProps {
    modalTitle: string,
    isOpen: boolean,
    onClose: any,
    children: any,
    primaryAction?: any,
    primaryButtonText?: string
    form?: string,
    size?: string,
    primaryActionButtonType?: 'button' | 'submit' | 'reset',
    isLoading?: boolean,
    disablePrimaryButton?: boolean,
    hideCancelButton?: boolean,
    hidePrimaryButton?: boolean
}

const ChakraModal = ({
    isOpen = false,
    modalTitle = "Modal Title",
    onClose,
    children,
    form,
    primaryActionButtonType = 'submit',
    primaryButtonText = "Create",
    primaryAction,
    size = 'md',
    hideCancelButton = false,
    isLoading = false,
    disablePrimaryButton = false
}: IProps) => {

    return (
        <>
            <Modal
                closeOnOverlayClick={!isLoading}
                isOpen={isOpen}
                motionPreset='slideInBottom'
                onClose={onClose}
                size={size}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{modalTitle}</ModalHeader>
                    <ModalCloseButton autoFocus={false} _focus={{ border: 'none' }} />
                    <ModalBody pb={6}>
                        {children}
                    </ModalBody>

                    <ModalFooter>
                        <Button disabled={disablePrimaryButton || isLoading} isLoading={isLoading} type={primaryActionButtonType} form={form} onClick={primaryAction} colorScheme='blue' mr={3}>
                            {primaryButtonText}
                        </Button>
                        {!hideCancelButton && <Button onClick={() => onClose(false)}>Cancel</Button>}
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

export default ChakraModal